import { ViteReactSSG } from "vite-react-ssg";
import { routes } from "./App";
import { iniciarMarcadorCampanha } from "./lib/campanha";
import { capturarUtms } from "./lib/utms";

// Fontes self-hosted. Antes vinham do Google Fonts, que custava duas conexoes
// externas em cadeia (fonts.googleapis.com -> CSS -> fonts.gstatic.com -> woff2).
//
// Sao as versoes VARIAVEIS de proposito: um arquivo por familia cobre todos os
// pesos em 86 KB no total -- exatamente o que o Google Fonts ja servia, e menos
// que os 96 KB em 4 arquivos que a versao estatica por peso baixava nesta home.
// Cada @font-face tem `unicode-range`, entao o navegador baixa so o subset
// latin. `font-display: swap` vem do proprio @fontsource.
import "@fontsource-variable/playfair-display/wght.css";
import "@fontsource-variable/inter/wght.css";

import "./index.css";

// Continua no topo do modulo, e nao dentro do callback do ViteReactSSG, porque
// precisa valer no primeiro instante: a pagina fica clicavel muito antes de o
// GTM carregar (ver src/lib/campanha.ts e o bug de 29/07 no CLAUDE.md). A
// funcao ja e no-op fora do navegador e idempotente, entao rodar aqui e seguro
// durante a geracao estatica.
iniciarMarcadorCampanha();

// Mesmo motivo do de cima, outro destino: os UTMs da URL de entrada precisam
// estar guardados antes da primeira troca de rota, senao o formulario do
// /wellness grava o lead sem origem. Ver src/lib/utms.ts.
capturarUtms();

export const createRoot = ViteReactSSG({ routes });
